import React, { Component } from "react";
import Roadmap from "./assets/roadmap.jpg";
/**
 * This code defines the react app
 *
 * Imports the router functionality to provide page navigation
 * Defines the Home function outlining the content on each page
 * Content specific to each page (Home and About) is defined in their components in /pages
 * Each page content is presented inside the overall structure defined here
 * The router attaches the page components to their paths
 */

// Import and apply CSS stylesheet
import "./styles/bootstrap.min.css";
import "./styles/styles.css";
import "./styles/2.ca72bb68.chunk.css";
import "./styles/toastr.min.css";

// Where all of our pages come from
import PageRouter from "./components/router";
import Header from "./components/header";
import Footer from "./components/footer";
// import AppContext from "./components/appContext";
import { BrowserRouter } from "react-router-dom";

// The component that adds our Meta tags to the page
import Web3 from "web3";

import { Configurations } from "./libs/launchPad";
import ModalImage from "./components/modalImage";

class App extends Component {
  config = Configurations.mainnetConfig();
  constructor(props) {
    super(props);
    this.state = {
      provider: null,
      account: null,
      accountBalance: 0,
      connected: false,
      chainId: "0x38",
      isWrongChainSelected: false,
      test: 2,
      transactions: [],
    };
  }

  getBalance = (loop) => {
    if (this.state.connected && this.state.provider != null) {
      const _web3 = new Web3(this.state.provider);
      _web3.eth.getBalance(this.state.account).then((balance) => {
        this.setState({
          accountBalance: parseFloat(_web3.utils.fromWei(balance)).toFixed(4),
        });
      });
      if (loop) {
        setTimeout(() => {
          this.getBalance(true);
        }, 15000);
      }
    }
  };

  setChainId = (chainId) => {
    this.getBalance(false);
    this.setState({
      chainId: chainId,
      isWrongChainSelected: this.isWrongChainSelected(chainId),
    });
  };
  isWrongChainSelected = (chainId) => {
    return (
      parseInt(chainId) !== this.config.chainId
    );
  };
  updateDappStatus = (connected, account, provider) => {
    this.setState({
      connected,
      account,
      provider,
    });
    if (connected) {
      this.getBalance(true);
    }
    //console.log({ connected, account, provider });
  };

  render() {
    return (
      <BrowserRouter>
        <Header
          state={this.state}
          config={this.config}
          updateDappStatus={this.updateDappStatus}
          setChainId={this.setChainId}
          isWrongChainSelected={this.isWrongChainSelected}
        />

        <PageRouter state={this.state} config={this.config} />
        <ModalImage id="roadmapModal" src={Roadmap} />
        <Footer />
      </BrowserRouter>
    );
  }
}

export default App;

// import logo from './logo.svg';

// import './App.css';
// import Web3 from "web3";
// import Web3Modal from "web3modal";
// import WalletConnectProvider from "@walletconnect/web3-provider";

// function App() {

//   const providerOptions = {

//   };

//   const connectWallet = async (e) => {
//     const web3Modal = new Web3Modal({
//       network: "mainnet", // optional
//       cacheProvider: true, // optional
//       providerOptions // required
//     });

//     const provider = await web3Modal.connect();

//     const web3 = new Web3(provider);

//   }
//   return (
//     <div className="App">
//       <header className="App-header">
//         <img src={logo} className="App-logo" alt="logo" />
//         <p>
//           Edit <code>src/App.js</code> and save to reload.
//         </p>
//         <a
//           className="App-link"
//           href="https://reactjs.org"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           Learn React
//         </a>
//         <button onClick={connectWallet}>Connect Wallet</button>
//       </header>
//     </div>
//   );
// }

// export default App;
